import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { FavouriteGroup } from '@/models/FavouriteGroup'

export default new CachedResourceStore<FavouriteGroup>(FavouriteGroup, {
	namespaced: true,
})
